function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import * as DialogPrimitive from '@grupoboticario/flora-react-dialog';
import { forwardRef, styled } from '@grupoboticario/flora-react-system';

/**
 * @component
 * @name Modal
 * @description Modal component
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var Modal = props => {
  return /*#__PURE__*/React.createElement(DialogPrimitive.Dialog, _extends({}, props, {
    "data-flora": "modal"
  }));
};
var StyledContent = styled(DialogPrimitive.DialogContent, {
  position: 'fixed',
  backgroundColor: '$backgroundPrimary',
  boxShadow: '$colors$shadowLight 0 10px 38px -10px, $colors$shadowDark 0 10px 20px -15px',
  borderRadius: '$large $large 0 0',
  boxSizing: 'border-box',
  zIndex: '$modal',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%',
  bottom: 0,
  left: 0,
  height: 'fit-content',
  maxHeight: '100%',
  '@tablet': {
    height: 'fit-content',
    borderRadius: 0,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  variants: {
    size: {
      small: {
        '@tablet': {
          maxWidth: '28rem',
          minWidth: '28rem'
        }
      },
      standard: {
        '@tablet': {
          maxWidth: '48rem',
          minWidth: '48rem'
        }
      },
      large: {
        '@tablet': {
          maxWidth: '58rem',
          minWidth: '58rem'
        }
      }
    },
    isFull: {
      true: {
        maxWidth: '100%',
        height: '100%',
        borderRadius: 0,
        inset: 0,
        transform: 'translate(0, 0)'
      }
    }
  },
  defaultVariants: {
    size: 'standard'
  }
});
var StyledBody = styled(DialogPrimitive.DialogBody, {});
var StyledHeader = styled(DialogPrimitive.DialogHeader, {});
var StyledFooter = styled(DialogPrimitive.DialogFooter, {});
var StyledTrigger = styled(DialogPrimitive.DialogTrigger, {});
var StyledClose = styled(DialogPrimitive.DialogClose, {});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalContent = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledContent, _extends({}, props, {
    "data-flora": "modal-content",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalBody = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledBody, _extends({}, props, {
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalHeader = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledHeader, _extends({}, props, {
    "data-flora": "modal-header",
    ref: forwardedRef
  }));
});
/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalFooter = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledFooter, _extends({}, props, {
    "data-flora": "modal-footer",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalTrigger = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledTrigger, _extends({}, props, {
    asChild: true,
    "data-flora": "modal-trigger",
    ref: forwardedRef
  }));
});

/**
 * @tutorial https://flora.gb.tech/docs/components/core/modal
 */
export var ModalCloseButton = forwardRef((props, forwardedRef) => {
  return /*#__PURE__*/React.createElement(StyledClose, _extends({}, props, {
    "data-flora": "modal-close",
    ref: forwardedRef
  }));
});
//# sourceMappingURL=Modal.js.map